<div class="EFProductMap">
    @if (!getItineraryId() && productData.geolocation != null) {
        <div class="EFProductMap-Simple">
            <div #gmapsElement class="EFProductMap-Simple-Map GoogleMaps"></div>
        </div>
    }
    @if (getItineraryId()) {
        <div class="EFProductMap-Itinerary">
            @if (isLoadingItinerary) {
                <app-pg-loading></app-pg-loading>
            }
            @if (!isLoadingItinerary && itineraryData != null) {
                @if (!hideMap) {
                    <div class="EFProductMap-Itinerary-Map">
                        @if (isItineraryFullyLoaded) {
                            <app-ef-itinerary-map [itineraryData]="itineraryData"></app-ef-itinerary-map>
                        }
                    </div>
                }
                @if (!hideList) {
                    <div class="EFProductMap-Itinerary-List">
                        @for (item of itineraryData.collection; track item) {
                            <div class="EFProductMap-Itinerary-List-Item">
                                <div>
                                    <app-ef-itinerary-stop-card [singleDay]="itineraryData.single_day" [stopData]="item" (showStop)="onShowStop(item)"></app-ef-itinerary-stop-card>
                                </div>
                            </div>
                        }
                    </div>
                }
            }
        </div>
    }
</div>